import React from 'react';
import PropTypes from 'prop-types';


function ImageContent(props) {
  const { title, src } = props;
  return (
    <div className="c-image-content">
      <h2 className="image-title">{title}</h2>
      <div className="image-container">
        <img className="image" src={src} alt="Not available" />
      </div>
    </div>
  );
}

ImageContent.propTypes = {
  title: PropTypes.string,
  src: PropTypes.string
};

export default ImageContent;



// WEBPACK FOOTER //
// ./app/components/common/modals/ImageContent.jsx